import clsx from "clsx";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import { FeatureNameEnum, PostTypeEnum } from "@/generated/generated-hooks";

type PostTypeFilterProps = {
  currentTypes: PostTypeEnum[];
  onClick: (type: PostTypeEnum[]) => void;
};

export const PostTypeFilter = ({
  currentTypes,
  onClick,
}: PostTypeFilterProps) => {
  const { t } = useTranslation("common");
  const { isEnabled } = useFeatureEnabled();
  const isNFTEnabled = isEnabled(FeatureNameEnum.Nft);

  const activeClassName = "text-gray-900 cursor-default";
  const inactiveClassName = "text-gray-300 touchable";

  const getClassName = (type: PostTypeEnum | null) => {
    if (currentTypes.length === 0 && type === null) return activeClassName;

    if (currentTypes.includes(type)) return activeClassName;
    return inactiveClassName;
  };

  if (!isNFTEnabled) return null;

  return (
    <div className="flex" data-test-id="PostTypeFilter-container">
      <span
        className={clsx("text-2xl", getClassName(null))}
        onClick={() => {
          firebase.analytics().logEvent(AnalyticsEventEnum.AllPost);
          onClick([]);
        }}
      >
        {t("postTypeFilter.all")}
      </span>

      <div className="flex items-center px-5">
        <span className="block h-2/4 border-r border-solid border-gray-300 rotate-25" />
      </div>

      <span
        className={clsx(
          "text-2xl",
          getClassName(PostTypeEnum.Normal) ??
            getClassName(PostTypeEnum.Article),
        )}
        onClick={() => {
          firebase.analytics().logEvent(AnalyticsEventEnum.NormalPost);
          onClick([
            PostTypeEnum.Article,
            PostTypeEnum.Normal,
            PostTypeEnum.Video,
          ]);
        }}
      >
        {t("postTypeFilter.posts")}
      </span>

      <div className="flex items-center px-5">
        <span className="block h-2/4 border-r border-solid border-gray-300 rotate-25" />
      </div>

      <span
        className={clsx("text-2xl", getClassName(PostTypeEnum.Nft))}
        onClick={() => {
          firebase.analytics().logEvent(AnalyticsEventEnum.Collectible);
          onClick([PostTypeEnum.Eth721]);
        }}
      >
        {t("postTypeFilter.nft")}
      </span>
    </div>
  );
};
